import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';
import store from '@/store/index';
import { selectLowStreamConfig } from './selectLowStreamConfig';

export default {
  // Enable dual-stream mode to enable switching between high and low stream quality
  async enableDualStream() {
    try {
      // video profile of the low-quality stream, selected based on measured bandwidth
      const measuredBandwidth = store.getters['videoRtc/measuredBandwidth'];
      const lowStreamConfig = selectLowStreamConfig(measuredBandwidth);
      this.rtc.setLowStreamParameter(lowStreamConfig);

      await this.rtc.enableDualStream();

      logger.info(`${joinPrefix('Agora')} Dual stream mode enabled successfully`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));
    } catch (error) {
      logger.debug('[Agora] Error while enabling dual stream', {
        operation: 'enable:dual-stream',
        error: error.message
      });

      logger.warn(`${joinPrefix('Agora')} Failed to enable dual stream mode: ${error.message}`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));
    }
  }
};
